module.exports = __webpack_public_path__ + "static/media/navigate.c671df13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navigate.svg
// module id = 511
// module chunks = 0 1